import React from 'react';
import Modal from '@/ctComponents/Modal';
import CloseButton from '@/ctComponents/closeButton';
import { ReactSVG } from 'react-svg';
import { Icons, TerminalsIcon } from '@/assets';
import { removeNoScroll } from '@/actions/Helper';
import abStyles from '@/ctComponents/AppointmentTable/ActionButton/ActionButton.module.css';
import styles from './AvailabilitySnapshotModal.module.css';

const AvailabilitySnapshotModal = ({
  open,
  onClose,
  terminalSlug,
  rows,
}) => {
  const handleClose = () => {
    removeNoScroll();
    if (typeof onClose === 'function') onClose();
  };

  const count = Array.isArray(rows) ? rows.length : 0;
  const iconKey = terminalSlug?.replace(/\s+/g, '') || '';

  return (
    <Modal
      show={open}
      setShow={(v) => {
        if (!v) handleClose();
      }}
      icon="calendarday"
      title="Availability Snapshot"
      titleColor="#2b303b"
      notClose={false}
      minWidth={540}
      maxHeight="min(72vh, 520px)"
      children={
        <div className={styles.root} onClick={(e) => e.stopPropagation()}>
          <div className={abStyles.content}>
            <div className={abStyles.logoSection}>
              <div
                className={abStyles.terminalLink}
                style={{ display: 'flex', alignItems: 'center' }}>
                {TerminalsIcon[iconKey] ? (
                  <img width={100} src={TerminalsIcon[iconKey]} alt={terminalSlug || ''} />
                ) : (
                  <div
                    style={{
                      width: 100,
                      minHeight: 48,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 13,
                      fontWeight: 600,
                      color: '#717784',
                      textAlign: 'center',
                    }}>
                    {terminalSlug || '—'}
                  </div>
                )}
              </div>
              <div className={abStyles.verticalDashed} />
            </div>
          </div>

          <table className={`${abStyles.table} ${styles.snapshotTable}`}>
            <thead>
              <tr>
                <th className={`${abStyles.th} ${styles.snapshotTh}`}>
                  <div className={styles.snapshotHeaderInner}>
                    <ReactSVG src={Icons.calendartime} className={abStyles.icon} />
                    Available Time
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className={abStyles.tableContainer}>
              {count === 0 ? (
                <tr>
                  <td className={abStyles.td} style={{ padding: '20px 8px' }}>
                    <div className={abStyles.tableCell}>
                      <span className={abStyles.none}>No time slots</span>
                    </div>
                  </td>
                </tr>
              ) : (
                rows.map((r, i) => (
                  <tr className={styles.slotRow} key={r.id || i}>
                    <td className={`${abStyles.td} ${styles.slotCell}`}>
                      <div
                        className={styles.slotCellInner}
                        style={{
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}>
                        {r.text ?? '—'}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div className={abStyles.footer} style={{ justifyContent: 'flex-end' }}>
            <div className={abStyles.buttonsContainer}>
              <CloseButton onClick={handleClose} text="Close" />
            </div>
          </div>
        </div>
      }
    />
  );
};

export default AvailabilitySnapshotModal;
